<template>
  <div class="question-edit" v-loading="editorLoading">
    <p class="title"><i>*</i>题型
      <span class="pull-right" v-if="!hideScore">
        <i
        style="color: #f53d3d;line-height: 16px;"
          v-if="!structTag.includes('xuanci') && !structTag.includes('tizu') && scoreCheck"
        >*</i>
        <i
          class="el-icon-edit"
          v-if="!scoreEdit"
          @click="scoreEdit = true"
        ></i>
        <i
          class="el-icon-check"
          v-if="scoreEdit"
          @click="scoreEdit = false"
        ></i>
        <em v-if="!scoreEdit">{{ question.score || 0}}</em>
        <el-input-number
          v-if="scoreEdit"
          v-model="question.score"
          controls-position="right"
          :min="0"
          :max="100"
          :precision="1"
          step-strictly
          :step="0.5"
          size="small"
          class="height22"
          @blur="scoreEdit = false"
          @change="changeBigScore"
        ></el-input-number>
        分
      </span>
    </p>
    <el-select
      v-model="question.questionTypeId"
      placeholder="请选择题型"
      clearable
      class="select36"
      style="width: 305px;"
      :disabled="typeDisabled"
      @change="changeQuestionType"
    >
      <el-option
        v-for="item in basicQuestionType"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <!-- 题干 -->
    <p class="title"><i>*</i>{{ structTag.includes('tizu') || structTag.includes('xuanci') ? '大题题干' : '题干'}}</p>
    <c-editor
      class="stem-input"
      :curSub="curSub"
      :curStep="curStep"
      ref="tinyce-stem"
      id="tinyce-stem"
      v-model="question.stem"
      itemName="question"
    >
    </c-editor>
    <!-- 单选，加答案 -->
    <template v-if="structTag.includes('option-1')">
      <p class="title"><i>*</i>选项与答案</p>
      <div
        v-for="(item, key) in question.options"
        :key="key"
        class="question-options"
      >
        <el-radio
          :label="key"
          v-model="question.answer"
        ></el-radio>
        <c-editor
          class="option-input"
          :curSub="curSub"
          :curStep="curStep"
          :ref="'tinyce-option-' + key"
          :id="'tinyce-option-' + key"
          v-model="question.options[key]"
          itemName="option"
          :minHeight="18"
          :isFixed="false"
        >
        </c-editor>
        <i
          class="el-icon-remove-outline"
          v-if="!['A', 'B'].includes(key)"
          @click.stop="delOptions(key)"
        ></i>
        <i
          class="el-icon-circle-plus-outline"
          @click.stop="addOptions(key)"
        ></i>
      </div>
      <i
        v-if="isEmpty(question.options)"
        class="el-icon-circle-plus-outline"
        @click.stop="addOptions()"
      ></i>
    </template>
    <!-- 多选，加答案 -->
    <template v-if="structTag.includes('option-2')">
      <p class="title"><i>*</i>选项与答案</p>
      <div
        v-for="(item, key) in question.options"
        :key="key"
        class="question-options"
      >
        <el-checkbox
          v-if="!hideAnswer"
          :label="key"
          :checked="question.answer.indexOf(key) > -1"
          @change="changeOption2(key)"
        ></el-checkbox>
        <c-editor
          class="option-input"
          :curSub="curSub"
          :curStep="curStep"
          :ref="'tinyce-option-' + key"
          :id="'tinyce-option-' + key"
          v-model="question.options[key]"
          itemName="option"
          :minHeight="18"
          :isFixed="false"
        >
        </c-editor>
        <i
          class="el-icon-remove-outline"
          v-if="!['A', 'B'].includes(key)"
          @click.stop="delOptions(key)"
        ></i>
        <i
          class="el-icon-circle-plus-outline"
          @click.stop="addOptions(key)"
        ></i>
      </div>
      <i
        v-if="isEmpty(question.options)"
        class="el-icon-circle-plus-outline"
        @click="addOptions()"
      ></i>
    </template>
    <!-- 公共选项，无答案 -->
    <template v-if="structTag.includes('option-3')">
      <p class="title"><i>*</i>公共选项</p>
      <div
        v-for="(item, key) in question.options"
        :key="key"
        class="question-options"
      >
        {{ key }}
        <c-editor
          class="option-input"
          :curSub="curSub"
          :curStep="curStep"
          :ref="'tinyce-option-' + key"
          :id="'tinyce-option-' + key"
          v-model="question.options[key]"
          itemName="option"
          :minHeight="18"
          :isFixed="false"
        >
        </c-editor>
        <i
          class="el-icon-remove-outline"
          v-if="!['A', 'B'].includes(key)"
          @click.stop="delOptions(key)"
        ></i>
        <i
          class="el-icon-circle-plus-outline"
          @click.stop="addOptions(key)"
        ></i>
      </div>
      <i
        v-if="isEmpty(question.options)"
        class="el-icon-circle-plus-outline"
        @click.stop="addOptions()"
      ></i>
    </template>
    <!-- 判断题答案 -->
    <template v-if="structTag.includes('answer-1')">
      <p class="title"><i>*</i>答案</p>
      <el-radio-group v-model="question.answer">
        <el-radio label="对">对</el-radio>
        <el-radio
          label="错"
          style="margin-left: 12px;"
        >错</el-radio>
      </el-radio-group>
    </template>
    <!-- 填空题答案，需要特殊处理，存的时候用 #@# 做分割 -->
    <template v-if="structTag.includes('answer-2')">
      <p class="title"><i>*</i>答案</p>
      <div class="answer-list">
        <span
          v-for="(item, index) in question.children"
          :key="index"
          :class="curSub === index ? 'active' : ''"
          style="z-index: 1334"
          @click="selectSub(index)"
        >
          {{ '第' + (index + 1) + '空'}}
          <i
            class="el-icon-close"
            @click.stop="delSubQuestion(index)"
          ></i>
        </span>
        <i
          class="el-icon-circle-plus-outline"
          @click.stop="addSubQuestion"
        ></i>
      </div>
      <c-editor
        v-if="question.children && question.children[curSub]"
        class="answer-input"
        :curSub="curSub"
        :curStep="curStep"
        ref="tinyce-answer"
        id="tinyce-answer"
        v-model="question.children[curSub].answer"
        itemName="answer"
      >
      </c-editor>
    </template>
    <!-- 简单题答案 -->
    <template v-if="structTag.includes('answer-3')">
      <p class="title"><i>*</i>答案</p>
      <c-editor
        class="answer-input"
        :curSub="curSub"
        :curStep="curStep"
        ref="tinyce-answer"
        id="tinyce-answer"
        v-model="question.answer"
        itemName="answer"
      >
      </c-editor>
    </template>
    <!-- 解析 -->
    <p class="title">{{ structTag.includes('tizu') || structTag.includes('xuanci') ? '大题解析' : '解析'}}</p>
    <c-editor
      class="answer-input"
      :curSub="curSub"
      :curStep="curStep"
      ref="tinyce-analysis"
      id="tinyce-analysis"
      v-model="question.analysis"
      itemName="analysis"
    >
    </c-editor>
    <!-- 选词填空，小题类 -->
    <template v-if="structTag.includes('xuanci')">
      <p class="title"></p>
      <div class="answer-list">
        <span
          v-for="(item, index) in question.children"
          :key="index"
          :class="curSub === index ? 'active' : ''"
          style="z-index: 1334"
          @click="selectSub(index)"
        >
          {{ '第' + (index + 1) + '题'}}
          <i
            class="el-icon-close"
            @click.stop="delSubQuestion(index)"
          ></i>
        </span>
        <i
          class="el-icon-circle-plus-outline"
          @click.stop="addSubQuestion"
        ></i>
      </div>

      <template v-if="question.children && question.children.length > 0">
        <p class="title"  v-if="!hideScore">
          <i v-if="scoreCheck">*</i>小题分数
          <span class="pull-right">
            <i
              class="el-icon-edit"
              v-if="!subScoreEdit"
              @click="subScoreEdit = true"
            ></i>
            <i
              class="el-icon-check"
              v-if="subScoreEdit"
              @click="subScoreEdit = false"
            ></i>
            <em v-if="!subScoreEdit">{{ question.children[curSub].score || 0}}</em>
           <el-input-number
              v-if="subScoreEdit"
              v-model="question.children[curSub].score"
              controls-position="right"
              :min="0"
              :max="100"
              :precision="1"
              step-strictly
              :step="0.5"
              size="small"
              class="height22"
              @blur="subScoreEdit = false"
              @change="changeSmallScore"
            ></el-input-number>
            分
          </span>
        </p>

        <p class="title"><i>*</i>小题选项</p>
        <div
          v-for="(sitem, skey) in question.children[curSub].options"
          :key="skey"
          class="question-options"
        >
          <el-radio
            :label="skey"
            v-model="question.children[curSub].answer"
          ></el-radio>
          <c-editor
            class="option-input"
            :curSub="curSub"
            :curStep="curStep"
            :ref="'tinyce-sub-option-' + skey"
            :id="'tinyce-sub-option-' + skey"
            v-model="question.children[curSub].options[skey]"
            itemName="option"
            :minHeight="18"
            :isFixed="false"
          >
          </c-editor>
          <i
            class="el-icon-remove-outline"
            v-if="!['A', 'B'].includes(skey)"
            @click.stop="delSubOption(skey)"
          ></i>
          <i
            class="el-icon-circle-plus-outline"
            @click.stop="addSubOption(skey)"
          ></i>
        </div>
        <i
          v-if="isEmpty(question.children[curSub].options)"
          class="el-icon-circle-plus-outline"
          @click.stop="addSubOption()"
        ></i>
      </template>

      <p class="title">小题解析</p>
      <c-editor
        v-if="question.children[curSub]"
        class="answer-input"
        :curSub="curSub"
        :curStep="curStep"
        ref="tinyce-sub-analysis"
        id="tinyce-sub-analysis"
        v-model="question.children[curSub].analysis"
        itemName="analysis"
      >
      </c-editor>
    </template>

    <!-- 组题，小题类 -->
    <template v-if="structTag.includes('tizu')">
      <p class="title"></p>
      <div class="question-list">
        <span
          v-for="(item, index) in question.children"
          :key="index"
          :class="curSub === index ? 'active' : ''"
          @click="selectSub(index)"
          style="z-index: 1334"
        >
          {{ '第' + (index + 1) + '题'}}
          <i
            class="el-icon-close"
            @click.stop="delSubQuestion(index)"
          ></i>
        </span>
        <img src="../images/edit_add.svg" @click="addSubQuestion">
      </div>

      <template v-if="question.children && question.children.length > 0">
        <p class="title" v-if="!hideScore">
          <i>*</i>小题题型
          <span class="pull-right">
            <i style="color: #f53d3d;line-height: 16px;" v-if="scoreCheck">*</i>
            <i
              class="el-icon-edit"
              v-if="!subScoreEdit"
              @click="subScoreEdit = true"
            ></i>
            <i
              class="el-icon-check"
              v-if="subScoreEdit"
              @click="subScoreEdit = false"
            ></i>
            <em v-if="!subScoreEdit">{{ question.children[curSub].score || 0}}</em>
            <el-input-number
              v-if="subScoreEdit"
              v-model="question.children[curSub].score"
              controls-position="right"
              :min="0"
              :max="100"
              :precision="1"
              step-strictly
              :step="0.5"
              size="small"
              class="height22"
              @blur="subScoreEdit = false"
              @change="changeSmallScore"
            ></el-input-number>
            分
          </span>
        </p>
        <el-select
          v-model="question.children[curSub].questionTypeId"
          placeholder="请选择题型"
          :disabled="typeDisabled"
          clearable
          class="select36"
          style="width: 305px;"
          @change="changeSubType"
        >
          <el-option
            v-for="item in subBasicQuestionType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>

        <p class="title"><i>*</i>小题题干</p>
        <c-editor
          class="stem-input"
          :curSub="curSub"
          :curStep="curStep"
          ref="tinyce-sub-stem"
          id="tinyce-sub-stem"
          v-model="question.children[curSub].stem"
          itemName="question"
        >
        </c-editor>

        <!-- 小题单选，加答案 -->
        <template v-if="subStructTag.includes('option-1')">
          <p class="title"><i>*</i>小题选项</p>
          <div
            v-for="(sitem, skey) in question.children[curSub].options"
            :key="skey"
            class="question-options"
          >
            <el-radio
              :label="skey"
              v-model="question.children[curSub].answer"
            ></el-radio>
            <c-editor
              class="option-input"
              :curSub="curSub"
              :curStep="curStep"
              :ref="'tinyce-sub-option-' + skey"
              :id="'tinyce-sub-option-' + skey"
              v-model="question.children[curSub].options[skey]"
              itemName="option"
              :minHeight="18"
              :isFixed="false"
            >
            </c-editor>
            <i
              class="el-icon-remove-outline"
              v-if="!['A', 'B'].includes(skey)"
              @click.stop="delSubOption(skey)"
            ></i>
            <i
              class="el-icon-circle-plus-outline"
              @click.stop="addSubOption(skey)"
            ></i>
          </div>
          <i
            v-if="isEmpty(question.children[curSub].options)"
            class="el-icon-circle-plus-outline"
            @click.stop="addSubOption()"
          ></i>
        </template>
        <!-- 小题多选，加答案 -->
        <template v-if="subStructTag.includes('option-2')">
          <p class="title"><i>*</i>小题选项</p>
          <div
            v-for="(sitem, skey) in question.children[curSub].options"
            :key="skey"
            class="question-options"
          >
            <el-checkbox
              v-if="!hideAnswer"
              :label="skey"
              :checked="question.children[curSub].answer.indexOf(skey) > -1"
              @change="changeSubOption2(skey)"
            ></el-checkbox>
            <c-editor
              class="option-input"
              :curSub="curSub"
              :curStep="curStep"
              :ref="'tinyce-sub-option-' + skey"
              :id="'tinyce-sub-option-' + skey"
              v-model="question.children[curSub].options[skey]"
              itemName="option"
              :minHeight="18"
              :isFixed="false"
            >
            </c-editor>
            <i
              class="el-icon-remove-outline"
              v-if="!['A', 'B'].includes(skey)"
              @click.stop="delSubOption(skey)"
            ></i>
            <i
              class="el-icon-circle-plus-outline"
              @click.stop="addSubOption(skey)"
            ></i>
          </div>
          <i
            v-if="isEmpty(question.children[curSub].options)"
            class="el-icon-circle-plus-outline"
            @click.stop="addSubOption()"
          ></i>
        </template>
        <!-- 小题公共选项，无答案 -->
        <template v-if="subStructTag.includes('option-3')">
          <p class="title"><i>*</i>小题公共选项</p>
          <div
            v-for="(sitem, skey) in question.children[curSub].options"
            :key="skey"
            class="question-options"
          >
            {{ skey }}
            <c-editor
              class="option-input"
              :curSub="curSub"
              :curStep="curStep"
              :ref="'tinyce-sub-option-' + skey"
              :id="'tinyce-sub-option-' + skey"
              v-model="question.children[curSub].options[skey]"
              itemName="option"
              :minHeight="18"
              :isFixed="false"
            >
            </c-editor>
            <i
              class="el-icon-remove-outline"
              v-if="!['A', 'B'].includes(skey)"
              @click.stop="delSubOption(skey)"
            ></i>
            <i
              class="el-icon-circle-plus-outline"
              @click.stop="addSubOption(skey)"
            ></i>
          </div>
          <i
            v-if="isEmpty(question.children[curSub].options)"
            class="el-icon-circle-plus-outline"
            @click.stop="addSubOption()"
          ></i>
        </template>
        <!-- 小题判断题答案 -->
        <template v-if="subStructTag.includes('answer-1')">
          <p class="title"><i>*</i>小题答案</p>
          <el-radio-group v-model="question.children[curSub].answer">
            <el-radio label="对">对</el-radio>
            <el-radio
              label="错"
              style="margin-left: 12px;"
            >错</el-radio>
          </el-radio-group>
        </template>
        <!-- 小题填空题答案，需要特殊处理，存的时候用 #@# 做分割 -->
        <template v-if="subStructTag.includes('answer-2')">
          <p class="title"><i>*</i>小题答案</p>
          <div class="answer-list">
            <span
              v-for="(item, index) in question.children[curSub].children"
              :key="index"
              :class="curSubAnswer === index ? 'active' : ''"
              style="z-index: 1334"
              @click="selectSubAnswer(index)"
            >
              {{ '第' + (index + 1) + '空'}}
              <i
                class="el-icon-close"
                @click.stop="delSubAnswer(index)"
              ></i>
            </span>
            <i
              class="el-icon-circle-plus-outline"
              @click.stop="addSubAnswer"
            ></i>
          </div>
          <c-editor
            v-if="question.children[curSub].children && question.children[curSub].children[curSubAnswer]"
            class="answer-input"
            :curSub="curSub"
            :curStep="curStep"
            ref="tinyce-sub-answer"
            id="tinyce-sub-answer"
            v-model="question.children[curSub].children[curSubAnswer].answer"
            itemName="answer"
          >
          </c-editor>
        </template>
        <!-- 小题简单题答案 -->
        <template v-if="subStructTag.includes('answer-3')">
          <p class="title"><i>*</i>小题答案</p>
          <c-editor
            class="answer-input"
            :curSub="curSub"
            :curStep="curStep"
            ref="tinyce-sub-answer"
            id="tinyce-sub-answer"
            v-model="question.children[curSub].answer"
            itemName="answer"
          >
          </c-editor>
        </template>

        <p class="title">小题解析</p>
        <c-editor
          v-if="question.children[curSub]"
          class="answer-input"
          :curSub="curSub"
          :curStep="curStep"
          ref="tinyce-sub-analysis"
          id="tinyce-sub-analysis"
          v-model="question.children[curSub].analysis"
          itemName="analysis"
        >
        </c-editor>
      </template>
    </template>

    <!-- 标签 -->
      <p class="title">知识点</p>
      <check-knows
        :question="question.questionTag"
        :questionId="question.questionTag.id"
        :subjectId="question.questionTag.subjectId"
        :stageId="question.questionTag.stageId"
      ></check-knows>
      <p class="title">难度</p>
      <el-select
        v-model="question.questionTag.questionDifficultId"
        placeholder="请选择难度"
        class="select36"
      >
        <el-option
          v-for="item in difficultList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    <div
      v-if="page === 'split'"
      class="btn pointer"
      @click="doSave"
    >
      {{ [7, 8].includes(question.structId) && question.children && question.children.length > 1 && curSub < question.children.length - 1 ? '保存，下一小题' : '保存，下一题'}}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CEditor from "@/components/editor4/CEditor";
import checkKnows from "@/pages/htmlSplit/components/check-knows";
import { isEmpty, deepClone } from '@/utils/tools'

const structObj = {
  10001: ["option-1"],
  10002: ["option-2"],
  10003: ["answer-1"],
  10004: ["answer-2"], // 伪大小题类，存的不是，编辑的时候是
  10005: ["answer-3"],
  10006: ["option-3", "answer-3"],
  10007: ["xuanci"], // 大小题类
  10008: ["tizu"], // 大小题类
  10009: ["answer-3"],
  10010: ["answer-3"]
};
export default {
  created() {
    tinymce = window.tinymce;
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    curStep: {
      type: Number,
      default: -1,
    },
    typeDisabled: {
      type: Boolean,
      default: false
    },
    notEdit: {
      type: Boolean,
      default: false
    },
    scoreCheck: {
      type: Boolean,
      default: false
    },
    hideScore: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: ''
    },
  },
  mounted() {
    this.initTinyEditor("mounted");
    // this.$nextTick(() => {
    //   MathJax.Hub.Queue([
    //     "Typeset",
    //     MathJax.Hub,
    //     document.getElementById("app"),
    //   ]);
    // });
  },
  updated() {
    // 渲染数学公式
    // this.$nextTick(() => {
    //   MathJax.Hub.Queue([
    //     "Typeset",
    //     MathJax.Hub,
    //     document.getElementById("app"),
    //   ]);
    // });
  },
  data() {
    return {
      lastStruct: '', // 上一次结构
      hideAnswer: false, // 隐藏多选答案
      scoreEdit: false,
      subScoreEdit: false,
      curSub: 0,
      curSubAnswer: 0,
      editorLoading: false,
      isInit: true,
      curTinymceList: [],
      curStruct: 10005,
      curSubStruct: 10005,
      structTag: [],
      subStructTag: [],
    };
  },
  computed: {
    ...mapState({
      // 不要6 m选n
      basicQuestionType(state) {
        return state.basicDataV3.basicQuestionType.filter(item => {
          return !isEmpty(item.structureTypeId) && item.structureTypeId !== 6
        })
      },
      subBasicQuestionType(state) {
        return state.basicDataV3.basicQuestionType.filter(item => {
          return !isEmpty(item.structureTypeId) && [1, 2, 3, 4, 5].includes(+item.structureTypeId)
        })
      },
      difficultList(state) {
        return state.basicDataV3.difficultList;
      },
    }),
    question: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    // 这里要注意一个问题，question先拿到下一题的，在切换题组结构，会有短暂报错
    curStep: {
      handler(newVal) {
        if (newVal === -1) {
          return;
        }
        // 大题
        this.curSub = 0
        this.scoreEdit = false;
        this.subScoreEdit = false
        this.hideAnswer = true
        this.$nextTick(() => {
          if (document.getElementsByClassName('question-tag')[0]) {
            document.getElementsByClassName('question-tag')[0].scrollTo(0, 0)
          }
          this.changeQuestionType('init');
          this.hideAnswer = false
        });
      },
      immediate: true,
    },
  },
  methods: {
    changeBigScore() {
      this.$nextTick(() => {
        if (this.question.children && this.question.children.length > 0) {
          let leftScore = this.question.score
          let childLen = this.question.children.length || 1
          // 找到离整数最近的平均数(0.5不找)
          let is05 = Number.isInteger(this.question.score * 2 / childLen)
          console.log(is05);
          let aviScore = Number((this.question.score / childLen).toFixed(1))
          console.log(aviScore);
          if (!is05) {
            aviScore = Math.ceil((this.question.score / childLen))
          }

          this.question.children.forEach(citem => {
            let score = citem.splitScore ? +citem.splitScore : 0
            console.log(score, leftScore);
            if (!score) {
              score = leftScore > aviScore ? aviScore : leftScore
              leftScore = leftScore - score
            }
            else {
              score = leftScore > score ? score : leftScore
              leftScore = leftScore - score
            }
            citem.score = score
          })
        }
      })
    },
    changeSmallScore() {
      this.$nextTick(() => {
        this.question.score = this.question.children.reduce((total, current) => {
          return total + current.score;
        }, 0);
      })
    },
    findCapitalLetter(text, obj) {
        if (!text) {
            return ""
        }
        if (!obj) {
            return ""
        }
        let result = '';
        // 使用正则表达式匹配所有的大写英文字母
        const matches = text.match(/[A-Z]/g);
        // 如果存在匹配的结果，则将它们组合成一个新的字符串，否则返回空字符串
        let str = matches ? matches.join('') : '';

        // 遍历字符串中的每一个字符
        for (let i = 0; i < str.length; i++) {
            let char = str[i];
            // 检查当前字符是否是对象的一个键
            if (obj.hasOwnProperty(char)) {
                // 如果是，将它添加到结果字符串
                result += char;
            }
        }

        return result;
    },
    findCapitalJudge(text) {
        if (!text) {
            return ""
        }
        // 使用正则表达式匹配所有的大写英文字母
        const matches = text.match(/(对|错|正确|错误|T|F)/);
        // 如果存在匹配的结果，则将它们组合成一个新的字符串，否则返回空字符串
        let str = matches ? matches[0] : '';
        let map = {
            '对': '对',
            '错': '错',
            '正确': '对',
            '错误': '错',
            'T': '对',
            'F': '错'
        }
        return map[str] || '';
    },
    getTextFromTag(htmlString) {
      let textContent = "";
      if (!htmlString) {
        return "";
      }
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        textContent = doc.documentElement.textContent;
        return textContent;
      } catch (error) {
        return htmlString;
      }
    },
    // 判断字符串是否含不允许字符
    judgeCapitalLetter(text, allowedChars, count) {
        if (!text) {
          return true
        }
        text = this.getTextFromTag(text)

        text = text.replace(/\s+/g, '');
        if (!text) {
            return true
        }
        if (!allowedChars || allowedChars.length === 0) {
            return true
        }
        if (count === 1) {
          return !allowedChars.includes(text)
        }
        // 有重复字符串也不合格
        const uniqueChars = new Set(text);
        if (uniqueChars.size !== text.length) {
          return true
        }
        // 有数组外的也不合格
        const pattern = allowedChars.join('|');
        const regex = new RegExp(`(${pattern})`, 'g');
        // 替换字符串中所有匹配的允许字符串
        const strippedString = text.replace(regex, '');
        // 如果替换后的字符串为空，则说明所有内容都是允许的
        return strippedString.length !== 0;
    },
    modifyAndSortString(str, char) {
      // 将字符串转换为数组，以便进行操作
      let arr = str.split('');
      // 检查数组中是否包含指定字符
      const index = arr.indexOf(char);
      if (index > -1) {
          // 如果字符存在，从数组中移除
          arr.splice(index, 1);
      } else {
          // 如果字符不存在，将字符添加到数组
          arr.push(char);
      }
      // 对数组进行排序
      arr.sort();
      // 将数组转换回字符串
      return arr.join('');
    },
    changeOption2(key) {
      this.question.answer = this.modifyAndSortString(this.question.answer, key)
    },
    changeSubOption2(key) {
      this.question.children[this.curSub].answer = this.modifyAndSortString(this.question.children[this.curSub].answer, key)
    },
    toast(text) {
      this.$message.error({
        message: text,
        duration: 2000,
      });
    },
    // 校验试题是否完整
    checkForm() {
      this.question.score = !this.question.score ? 0 : this.question.score
      if (this.scoreCheck && !this.hideScore) {
        if(![10007, 10008].includes(this.curStruct) && (!this.question.score || +this.question.score <= 0)) {
          this.toast('存在分数未填写')
          return false;
        }
        if([10007, 10008].includes(this.curStruct) && this.question.children && this.question.children.length > 0) {
          for(let i = 0; i < this.question.children.length; i++) {
            if(!this.question.children[i].score || +this.question.children[i].score <= 0) {
              this.toast('存在小题分数未填写')
              return false;
            }
          }
        }
      }
      // 题型必填
      if (isEmpty(this.question.questionTypeId)) {
        this.toast('题型不能为空！')
        return false;
      }
      // 题干必填
      if (isEmpty(this.question.stem)) {
        this.toast('题干不能为空！')
        return false;
      }
    //   // 难度必填
    //   if (isEmpty(this.question.questionTag) || isEmpty(this.question.questionTag.questionDifficultId)) {
    //     this.toast('难度不能为空！')
    //     return false;
    //   }
    //   // 知识点必填
    //  if (isEmpty(this.question.questionTag) || isEmpty(this.question.questionTag.knowledgePoints)) {
    //     this.toast('知识点不能为空！')
    //     return false;
    //   }
      let isOptions = !!(this.question.options && Object.keys(this.question.options).length > 1)
      // 选项还得看value有没有值
      if (this.question.options && Object.keys(this.question.options).length > 1) {
          for(let i in this.question.options) {
              if (this.question.options.hasOwnProperty(i) && !this.question.options[i]) {
                  isOptions = false
              }
          }
      }
      let isAnswer = !!this.question.answer
      let isChildren = this.question.children && this.question.children.length > 0

      if (this.curStruct === 10001) {
        if (!isOptions || !isAnswer) {
          this.toast('选项或答案不能为空！')
          return false
        }
        if (this.question.options && this.judgeCapitalLetter(this.question.answer, Object.keys(this.question.options), 2)) {
          this.toast('答案格式不对！')
          return false
        }
        let answer = this.findCapitalLetter(this.question.answer, this.question.options)
        answer = answer.substring(0, 1)
        this.question.answer = answer
        this.question.children = []
      }
      if (this.curStruct === 10002 || this.curStruct === 10006) {
        if (!isOptions || !isAnswer) {
          this.toast('选项或答案不能为空！')
          return false
        }
        if (this.question.options && this.judgeCapitalLetter(this.question.answer, Object.keys(this.question.options), 2)) {
          this.toast('答案格式不对！')
          return false
        }
        let answer = this.findCapitalLetter(this.question.answer, this.question.options)
        this.question.answer = answer
        this.question.children = []
      }
      if (this.curStruct === 10003) {
        if (!isAnswer) {
          this.toast('答案不能为空！')
          return false
        }
        if (this.judgeCapitalLetter(this.question.answer, ['对', '错', '正确', '错误', 'T', 'F'], 1)) {
          this.toast('答案格式不对！')
          return false
        }
        let answer = this.findCapitalJudge(this.question.answer)
        this.question.answer = answer
        this.question.options = {}
        this.question.children = []
      }
      if ([10005, 10009, 10010].includes(this.curStruct)) {
        if (!isAnswer) {
          this.toast('答案不能为空！')
          return false
        }
        this.question.options = {}
        this.question.children = []
      }
      if (this.curStruct === 10004) {
        if (!isChildren) {
          this.toast('小题不能为空！')
          return false;
        }
        for (let i = 0, len = this.question.children.length; i < len; i++) {
          let item = this.question.children[i];
          if (isEmpty(item.answer)) {
            this.toast(`小题${i + 1}答案不能为空！`)
            return false;
          }
        }
        this.question.options = {}
        this.question.answer = ""
      }
      if ([10007].includes(this.curStruct)) {
        if (!isChildren) {
          this.toast('小题不能为空！')
          return false;
        }
        for (let i = 0, len = this.question.children.length; i < len; i++) {
          let item = this.question.children[i];
          if (isEmpty(item.answer)) {
            this.toast(`小题${i + 1}答案不能为空！`)
            return false;
          }
          if (isEmpty(item.options)) {
            this.toast(`小题${i + 1}选项不能为空！`)
            return false;
          }
          if (!isEmpty(item.options)) {
            for (let key in item.options) {
              if (!item.options[key]) {
                this.toast(`小题${i + 1}选项${key}不能为空！`)
                return false;
              }
            }
          }
          item.stem = ""
          item.questionTypeId = ""
          item.structId = ""
          // item.analysis = ""
        }
        this.question.options = {}
        this.question.answer = ''
      }
      if ([10008].includes(this.curStruct)) {
        if (!isChildren) {
          this.toast('小题不能为空！')
          return false;
        }
        for (let i = 0, len = this.question.children.length; i < len; i++) {
            let item = this.question.children[i];
            if (isEmpty(item.questionTypeId)) {
              this.toast(`小题${i + 1}题型不能为空！`)
              return false;
            }
            if (isEmpty(item.stem)) {
              this.toast(`小题${i + 1}题干不能为空！`)
              return false;
            }
            if ([1, 2, 6].includes(item.structId)) {
              if (isEmpty(item.answer)) {
                this.toast(`小题${i + 1}答案不能为空！`)
                return false;
              }
              if (item.options && this.judgeCapitalLetter(item.answer, Object.keys(item.options), 2)) {
                this.toast(`小题${i + 1}答案格式不对！`)
                return false;
              }
              let answer = this.findCapitalLetter(item.answer, item.options)
              item.answer = item.structId === 1 ? answer.substring(0, 1) : answer
              if (isEmpty(item.options)) {
                 this.toast(`小题${i + 1}选项不能为空！`)
                return false;
              }
              if (!isEmpty(item.options) && Object.keys(item.options).length > 1) {
                for (let key in item.options) {
                  if (!item.options[key]) {
                    this.toast(`小题${i + 1}选项${key}不能为空！`)
                    return false;
                  }
                }
              }
              if(item.children) {
                delete item.children
              }
            }
            else if ([3].includes(item.structId)) {
              if (isEmpty(item.answer)) {
                this.toast(`小题${i + 1}答案不能为空！`)
                return false;
              }
              if (this.judgeCapitalLetter(item.answer, ['对', '错', '正确', '错误', 'T', 'F'], 1)) {
                this.toast(`小题${i + 1}答案结构不对！`)
                return false;
              }
              let answer = this.findCapitalJudge(item.answer)
              item.answer = answer
              item.options = {}
              if(item.children) {
                delete item.children
              }
            }
            else if ([5, 9, 10].includes(item.structId)) {
              if (isEmpty(item.answer)) {
                this.toast(`小题${i + 1}答案不能为空！`)
                return false;
              }
              item.options = {}
              if(item.children) {
                delete item.children
              }
            }
            else if ([4].includes(item.structId)) {
              if (isEmpty(item.children)) {
                this.toast(`小题${i + 1}答案不能为空！`)
                return false;
              }
              for (let j = 0, len = item.children.length; j < len; j++) {
                let citem = item.children[j];
                if (!citem || isEmpty(citem.answer)) {
                  this.toast(`小题${i + 1}答案${j + 1}不能为空！`)
                  return false;
                }
              }
              item.options = {}
              item.answer = ''
            }
          }
      }
      return true;
    },
    // 初始化富文本
    initTinyEditor(type) {
      this.setEditorLoading(true);
      // 初始化的时候先全清掉
      // if (type === "mounted" && this.curTinymceList.length > 0) {
        this.curTinymceList.forEach((item) => {
          if (tinymce.get(item)) {
            tinymce.get(item).destroy();
          }
        });
      //   return;
      // }
      this.$nextTick(() => {
        setTimeout(() => {
          let promiselist = [];
          let tinymceList = [
            "tinyce-stem",
            "tinyce-answer",
            "tinyce-comment",
            "tinyce-analysis",
            "tinyce-sub-stem",
            "tinyce-sub-answer",
            "tinyce-sub-analysis",
            "tinyce-sub-comment",
          ];
          for (let i = 65; i <= 90; i++) {
            tinymceList.push("tinyce-option-" + String.fromCharCode(i));
            tinymceList.push("tinyce-sub-option-" + String.fromCharCode(i));
          }
          let oldTinymceList = [...this.curTinymceList];
          let curTinymceList = [];
          tinymceList.forEach((item, index) => {
            if (!this.$refs[item] || this.$refs[item].length === 0) {
              return;
            }

            // 插入新的
            curTinymceList.push(item);
            // if (!oldTinymceList.includes(item)) {
              // 兜底
              if (tinymce.get(item)) {
                tinymce.get(item).destroy();
              }
              let p;
              if (this.$refs[item].length) {
                p = this.$refs[item][0].mountedInit();
              } else {
                p = this.$refs[item].mountedInit();
              }
              promiselist.push(p);
            // } else {
            //   // 答案每次都清除重新来
            //   if (['tinyce-answer'].includes(item)) {
            //     // 兜底
            //     if (tinymce.get(item)) {
            //       tinymce.get(item).destroy();
            //     }
            //     let p;
            //     if (this.$refs[item].length) {
            //       p = this.$refs[item][0].mountedInit();
            //     } else {
            //       p = this.$refs[item].mountedInit();
            //     }
            //     promiselist.push(p);
            //   }
            //   // 在老的删除
            //   oldTinymceList = oldTinymceList.filter((oitem) => oitem !== item);
            // }
          });
          // console.log(oldTinymceList);
          // 多余老的清除编辑器
          // oldTinymceList.forEach((item, index) => {
          //   if (tinymce.get(item)) {
          //     tinymce.get(item).destroy();
          //   }
          // });
          this.curTinymceList = curTinymceList;
          if (promiselist.length > 0) {
            Promise.all(promiselist).then((res) => {
              this.setEditorLoading(false);
            });
          } else {
            this.setEditorLoading(false);
          }
        }, 1000);
      });
    },
    setEditorLoading(val) {
      this.editorLoading = val;
    },
    isEmpty(value) {
      return isEmpty(value);
    },
    // 选择小题
    selectSub(index) {
      this.curSub = index;
      this.curSubAnswer = 0
      this.changeSubType('init')
    },
    selectAnswer(index) {
      this.curSub = index;
      this.initTinyEditor("selectAnswer");
    },
    // 删除小题
    delSubQuestion(index) {
      if (this.notEdit) {
        return;
      }
      if (this.question.children.length === 1) {
        this.$message.error("至少一个小题");
        return
      }
      if (index === this.curSub) {
        this.curSub = 0;
      } else {
        this.curSub = 0;
      }
      this.question.children.splice(index, 1)
      this.initTinyEditor("delSubQuestion");
    },
    // 新增小题
    addSubQuestion() {
      let structId = this.question.structId
      let object = {}
      if(structId === 7) {
        object = {
          'stem': '',
          'options': {
            'A': '',
            'B': '',
            'C': '',
            'D': ''
          },
          'answer': '',
          'analysis': '',
          'score': 0
        }
      }
      else if(structId === 8) {
        object = {
          'stem': '',
          'options': {},
          'answer': '',
          'analysis': '',
          'score': 0
        }
      }
      else if(structId === 4) {
        object = {
          stem: "",
          options: {},
          answer: "",
          analysis: ""
        }
      }
      if (this.question.children) {
        this.question.children.push(object)
      }
      else {
        this.question.children = [object]
      }
      this.initTinyEditor("addSubQuestion");
    },
    // 选择小题的小题
    selectSubAnswer(index) {
      this.curSubAnswer = index;
      this.initTinyEditor("selectSubAnswer");
    },
    delSubAnswer(index) {
      if (this.notEdit) {
        return;
      }
      if (this.question.children[this.curSub].children.length === 1) {
        this.$message.error("至少一个答案");
        return
      }
      if (index === this.curSubAnswer) {
        this.curSubAnswer = 0;
      } else {
        this.curSubAnswer = 0;
      }
      this.question.children[this.curSub].children.splice(index, 1)
      this.initTinyEditor("delSubAnswer");
    },
    addSubAnswer() {
      if (this.question.children[this.curSub].children) {
        this.question.children[this.curSub].children.push({
          'answer': ''
        })
      }
      else {
        this.question.children[this.curSub].children = [{
          'answer': ''
        }]
      }
      this.initTinyEditor("addSubAnswer");
    },
    // 删除选项
    delOptions(deleteKey) {
      let obj = this.question.options
      // 删除指定的键
      delete obj[deleteKey];

      // 获取剩余的键并按照字母顺序排序
      const keys = Object.keys(obj).sort();
      const newObject = {};

      // 重新编号键，假设是按照'A', 'B', 'C', ...的顺序
      keys.forEach((key, index) => {
        // 生成新的键名，从'A'开始
        const newKey = String.fromCharCode('A'.charCodeAt(0) + index);
        newObject[newKey] = obj[key];
      });

      this.question.options = newObject;
      if (this.question.answer === deleteKey) {
        this.question.answer = ""
      }
      this.initTinyEditor("delOptions");
    },
    insertPropertyAndShift(original, newPropName, newPropValue, afterPropName) {
      let newObject = {};
      let insertionPointFound = false;

      // 遍历原始对象的每个属性
      for (let key in original) {
          if (insertionPointFound) {
              // 如果已经插入了新属性，将后续的原始属性值顺延，即原key的值赋给key+1
              newObject[String.fromCharCode(key.charCodeAt(0) + 1)] = original[key];
          } else {
              // 复制现有属性到新对象
              newObject[key] = original[key];
          }

          // 当遇到指定的插入点后，添加新属性
          if (key === afterPropName) {
              newObject[newPropName] = newPropValue;
              insertionPointFound = true;
          }
      }

      // 如果指定的属性名不存在，将新属性添加到对象末尾
      if (!insertionPointFound) {
          newObject[newPropName] = newPropValue;
      }
      return newObject;
    },
    // 新增选项
    addOptions(key) {
      let obj = deepClone(this.question.options)
      if (!obj) {
        obj = {}
      }
      const keyMax = Object.keys(obj).length;
      const newKey = String.fromCharCode('A'.charCodeAt(0) + keyMax);
      if (key) {
        const insertKey = String.fromCharCode(key.charCodeAt(0) + 1);
        obj = this.insertPropertyAndShift(obj, insertKey, "", key);
      }
      else {
        obj[newKey] = "";
      }
      this.$nextTick(() => {
        this.question.options = obj
        this.initTinyEditor("addOptions");
      })
    },
    // 删除小题选项
    delSubOption(deleteKey) {
      if (this.notEdit) {
        return;
      }
      let obj = this.question.children[this.curSub].options
      // 删除指定的键
      delete obj[deleteKey];

      // 获取剩余的键并按照字母顺序排序
      const keys = Object.keys(obj).sort();
      const newObject = {};

      // 重新编号键，假设是按照'A', 'B', 'C', ...的顺序
      keys.forEach((key, index) => {
        // 生成新的键名，从'A'开始
        const newKey = String.fromCharCode('A'.charCodeAt(0) + index);
        newObject[newKey] = obj[key];
      });

      this.question.children[this.curSub].options = newObject;
      if (this.question.children[this.curSub].answer === deleteKey) {
        this.question.children[this.curSub].answer = ""
      }
      this.initTinyEditor("delSubOption");
    },
    // 新增小题选项
    addSubOption(key) {
      let obj = this.question.children[this.curSub].options
      if (!obj) {
        obj = {}
      }
      const keyMax = Object.keys(obj).length;
      const newKey = String.fromCharCode('A'.charCodeAt(0) + keyMax);
      if (key) {
        const insertKey = String.fromCharCode(key.charCodeAt(0) + 1);
        obj = this.insertPropertyAndShift(obj, insertKey, "", key);
      }
      else {
        obj[newKey] = "";
      }
      this.$nextTick(() => {
        this.question.children[this.curSub].options = obj
        this.initTinyEditor("addSubOption");
      })
    },
    // 保存
    doSave() {
      if ([7, 8].includes(this.question.structId) && this.question.children && this.question.children.length > 1 && this.curSub < this.question.children.length - 1) {
        this.selectSub(this.curSub + 1)
        this.$emit("save", 999999);
      }
      else {
        if (document.getElementsByClassName('question-tag')[0]) {
          document.getElementsByClassName('question-tag')[0].scrollTo(0, 0)
        }
        this.$emit("save", this.curStep);
      }
    },
    // 切换题型
    changeQuestionType(type = "") {
      let curStruct;
      // 没主动选择题型，都是用反推的结构
      if (type === 'init') {
        curStruct = this.question.structId ? (+this.question.structId + 10000) : 10005
      }
      else {
        curStruct = 10005
      }
      if (this.question.questionTypeId && _.find(this.basicQuestionType, { id: this.question.questionTypeId })) {
        let temp = _.find(this.basicQuestionType, { id: this.question.questionTypeId }).structureTypeId;
        if (temp) {
          curStruct = +temp + 10000
          this.question.structId = +temp
        }
        else {
          this.question.structId = curStruct - 10000
        }
      }
      else {
        this.question.structId = curStruct - 10000
      }
      // if (type !== 'init' && this.lastStruct !== curStruct) {
      //   // 不能跨题组和非题组
      //   if (([10007, 10008].includes(this.lastStruct) && [10007, 10008].includes(curStruct))
      //     || (![10007, 10008].includes(this.lastStruct) && ![10007, 10008].includes(curStruct))
      //   ) {
      //     this.$emit('changStruct', this.curStep + '-' + curStruct + '-' + this.question.questionTypeId)
      //     return
      //   }
      // }
      this.curStruct = curStruct
      this.structTag = structObj[this.curStruct];
      // 组题给初始值
      if (curStruct === 10008 && (!this.question.children || this.question.children.length === 0)) {
        this.question.children = [{
          structId: 5,
          questionTypeId: "",
          stem: "",
          options: {},
          answer: "",
          analysis: "",
          score: 0,
          orderNumber: this.question.orderNumber || '',
          questionNumber: this.question.questionNumber || ''
        }]
        this.question.questionNumber = ''
      }
      // 题组类型切换的时候补一些参数
      if (this.lastStruct !== curStruct && type !== 'init' && curStruct === 10008 && this.question.children && this.question.children.length > 0) {
        let typeId = _.find(this.basicQuestionType, { structureTypeId: 1 }) ? _.find(this.basicQuestionType, { structureTypeId: 1 }).id : ''
        this.question.children = this.question.children.map(item => {
          if (typeId) {
            return {
              structId: 1,
              questionTypeId: typeId,
              stem: "",
              options: item.options && Object.keys(item.options).length === 0 ? {
                'A': '',
                'B': '',
                'C': '',
                'D': ''
              } : item.options,
              answer: item.answer,
              analysis: item.analysis || '',
              score: item.score,
              orderNumber: item.orderNumber || '',
              questionNumber: item.questionNumber || ''
            }
          }
          return {
            structId: 5,
            questionTypeId: "",
            stem: "",
            options: {},
            answer: "",
            analysis: item.analysis || '',
            score: item.score,
            orderNumber: item.orderNumber || '',
            questionNumber: item.questionNumber || ''
          }
        })
        this.question.questionNumber = ''
      }
      if (curStruct === 10007 && (!this.question.children || this.question.children.length === 0)) {
        this.question.children = [{
          stem: "",
          options: {
            'A': '',
            'B': '',
            'C': '',
            'D': ''
          },
          answer: "",
          analysis: "",
          score: 0,
          orderNumber: this.question.orderNumber || '',
          questionNumber: this.question.questionNumber || ''
        }]
        this.question.questionNumber = ''
      }
      // 题组类型切换的时候补一些参数
      if (this.lastStruct !== curStruct && type !== 'init' && curStruct === 10007 && this.question.children && this.question.children.length > 0) {
        this.question.children = this.question.children.map(item => {
          return {
            stem: "",
            options:  item.options && Object.keys(item.options).length === 0 ? {
              'A': '',
              'B': '',
              'C': '',
              'D': ''
            } : item.options,
            answer: item.structId === 1 ? item.answer : '',
            analysis: item.analysis || '',
            score: item.score,
            orderNumber: item.orderNumber || '',
            questionNumber: item.questionNumber || ''
          }
        })
        this.question.questionNumber = ''
      }
      if (curStruct === 10004 && (!this.question.children || this.question.children.length === 0)) {
        this.question.children = [{
          stem: "",
          options: {},
          answer: "",
          analysis: ""
        }]
      }
      if ([10001, 10002, 10006].includes(curStruct) && isEmpty(this.question.options)) {
        this.question.options = {
          'A': "",
          'B': "",
          'C': "",
          'D': ""
        }
      }
      this.$emit("changeQuestionType", this.question.questionTypeId);
      if (curStruct === 10008 && this.question.children && this.question.children.length > 0) {
        this.changeSubType('init')
      }
      else {
        this.initTinyEditor("changeQuestionType");
      }
      this.lastStruct = curStruct // 记为上一个权限
    },
    // 切换小题题型
    changeSubType(type) {
      let subQuestion = this.question.children[this.curSub]
      let curSubStruct;
      if (type === 'init') {
        curSubStruct = subQuestion.structId ? (+subQuestion.structId + 10000) : 10005
      }
      else {
        curSubStruct = 10005
      }
      if (subQuestion.questionTypeId && _.find(this.basicQuestionType, { id: subQuestion.questionTypeId })) {
        let temp = _.find(this.basicQuestionType, { id: subQuestion.questionTypeId }).structureTypeId;
        if (temp) {
          curSubStruct = +temp + 10000
          subQuestion.structId = +temp
        }
      }
      this.curSubStruct = curSubStruct
      this.subStructTag = structObj[this.curSubStruct];
      if (curSubStruct === 10004 && (!subQuestion.children || subQuestion.children.length === 0)) {
        subQuestion.children = [{
          stem: "",
          options: {},
          answer: "",
          analysis: ""
        }]
      }
      if ([10001, 10002, 10006].includes(curSubStruct) && isEmpty(subQuestion.options)) {
        subQuestion.options = {
          'A': "",
          'B': "",
          'C': "",
          'D': ""
        }
      }
      this.$nextTick(() => {
        this.initTinyEditor("changeSubType");
      })
    }
  },
  components: {
    checkKnows,
    CEditor,
  },
  beforeDestroy() {
    // 移除所有富文本编辑器
    tinymce.remove();
  },
};
</script>

<style lang="scss" scoped>
.question-edit {
  padding: 0 16px 24px 16px;
  overflow: hidden;

  p.title {
    margin-top: 24px;
    margin-bottom: 4px;
    height: 22px;
    font-size: 14px;
    color: #1d2129;
    line-height: 22px;

    i {
      font-style: normal;
      color: #f53d3d;
      margin-right: 2px;
      vertical-align: middle;
    }

    span {
      line-height: 22px;
      font-size: 14px;
      color: #0fa784;
      cursor: pointer;

      i {
        color: #0fa784;
        margin-right: 4px;
        font-size: 16px;
        vertical-align: middle;
      }

      input {
        height: 22px;
        width: 80px;
        border: 1px solid #dcdfe6;
        padding: 0 0 0 10px;

        &:focus {
          border: 1px solid #dcdfe6;
          outline: none;
        }
      }

      em {
        font-style: normal;
      }
    }
  }

  div.check-info {
    width: 100%;
    height: 40px;
    background: #ffece8;
    border: 1px solid #f53d3d;
    border-radius: 4px;
    text-align: center;
    line-height: 38px;
    color: #f53d3d;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
    margin-top: 12px;

    p {
      color: #1d2129;

      span {
        margin: 0 8px;
        font-weight: bold;
      }

      i {
        color: #f53d3d;
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }

  div.check-info.green {
    background: #e2f5f0;
    color: #0fa784;
    border: 1px solid #0fa784;

    p {
      i {
        color: #0fa784;
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }

  div.stem-input {
    width: 100%;
    min-height: 100px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 7px 10px;
  }

  div.answer-input {
    width: 100%;
    min-height: 70px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 7px 10px;
  }

  div.question-options {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    .option-input {
      width: calc(100% - 120px);
      min-height: 32px;
      padding: 7px 10px;
      background: #ffffff;
      border: 1px solid #e5e6eb;
      border-radius: 2px;
      box-sizing: border-box;
      margin-left: 12px;
    }

    i {
      margin-left: 16px;
      font-size: 14px;
      font-size: 16px;
      vertical-align: middle;
    }
  }

  div.answer-list,
  div.question-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 12px;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 12px;
      margin-right: 16px;
      margin-bottom: 4px;
      border-radius: 2px;
      // background: #e7e7e7;
      color: #0fa784;
      line-height: 28px;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid #0fa784;
      box-sizing: border-box;

      i {
        color: #0fa784;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        margin-left: 10px;
        font-size: 16px;
        vertical-align: middle;
      }
    }

    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }

    span.active {
      background: #0fa784;
      border: 1px solid #0fa784;
      color: #fff;

      i {
        color: #fff;
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }

  div.btn {
    margin: 24px auto 0 auto;
    width: 116px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    background: #0fa784;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>

<style lang="scss">
.question-edit {
  .height22 {
    width: 100px;
    height: 22px !important;
    line-height: 22px !important;

    .el-input__inner {
      height: 22px !important;
      line-height: 22px !important;
    }

    .el-input-number__decrease,
    .el-input-number__increase {
      line-height: 11px !important;
      height: 11px !important;
    }
  }

  .el-radio {
    margin-right: 0;
  }

  div.check-info {
    .el-checkbox {
      color: inherit;
    }
    .el-checkbox__label {
      color: #1d2129;
    }
  }

  .tree-tag-wrap {
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 24px 0 20px;
    color: #c1c3c5;
    min-height: 30px;
    background: #fff;
    word-break: break-all;

    span {
      line-height: 30px;
    }

    .tree-arrow-down {
      position: absolute;
      top: 0;
      right: 4px;
      color: #c0c4cc;
      font-size: 14px;
      transform: rotateZ(0);
      cursor: pointer;
      width: 25px;
      text-align: center;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      line-height: 30px;
    }
    .tree-arrow-down.is-reverse {
      transform: rotateZ(180deg);
    }
  }

  .all-close-btn {
    position: absolute;
    right: 26px;
    top: 50%;
    margin-top: -5px;
    font-size: 16px;
  }
  .el-tag {
    position: relative;
    max-width: 100%;
    height: auto;
    padding: 0 22px 0 10px;
    margin: 3px 5px;
    white-space: inherit;

    .el-icon-close {
      position: absolute;
      top: 7px;
      right: 3px;
    }
  }
  // .button-new-tag {
  //   margin-left: 10px;
  //   height: 32px;
  //   line-height: 30px;
  //   padding-top: 0;
  //   padding-bottom: 0;
  // }
  // .input-new-tag {
  //   width: 90px;
  //   margin-left: 10px;
  //   vertical-align: bottom;
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/questionEdit.vue